import callAPI from '../ApiConfig'

/**
 * Get mizan units list with filters
 */
const getMizanUnits = async (props) => {
    return await callAPI({
        route: "mizan_units/",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

/**
 * Get lookups for filters (unit types, mizans, belongings, lifecycles)
 */
const getLookups = async (props) => {
    return await callAPI({
        route: "mizan_units/lookups",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

/**
 * Download Excel export
 */
const downloadExcel = async (props) => {
    return await callAPI({
        route: "mizan_units/download",
        method: "get",
        signal: props?.signal,
        params: {
            ...props?.params
        },
        headers: {},
        responseType: "blob"
    })
}

/**
 * Get mizan details for a specific unit
 */
const getMizanDetails = async (props) => {
    return await callAPI({
        route: `mizan_units/mizan-details/${props?.unitId}`,
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const mizanUnitAPI = {
    getMizanUnits,
    getLookups,
    getMizanDetails,
    downloadExcel
}

export default mizanUnitAPI
